class Wishlist {
  constructor() {
    this.storageKey = 'lj_wishlist';
    this.items = this.getItems();
    this.init();
  }

  getItems() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch {
      return [];
    }
  }

  saveItems() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.items));
  }

  hasItem(productId) {
    return this.items.some(i => String(i.id) === String(productId));
  }

  addItem(productId, handle, title, price, image, url) {
    if (!this.hasItem(productId)) {
      this.items.push({ id: String(productId), handle, title, price, image, url });
      this.saveItems();
    }
  }

  removeItem(productId) {
    this.items = this.items.filter(i => String(i.id) !== String(productId));
    this.saveItems();
  }

  toggleItem(productId, handle, title, price, image, url) {
    if (this.hasItem(productId)) {
      this.removeItem(productId);
      return false;
    } else {
      this.addItem(productId, handle, title, price, image, url);
      return true;
    }
  }

  getCount() {
    return this.items.length;
  }

  init() {
    this.updateAllButtons();
    this.updateCounters();
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (btn) {
        e.preventDefault();
        const productId = btn.dataset.wishlistToggle;
        const handle = btn.dataset.wishlistHandle || '';
        const title = btn.dataset.wishlistTitle || '';
        const price = btn.dataset.wishlistPrice || '';
        const image = btn.dataset.wishlistImage || '';
        const url = btn.dataset.wishlistUrl || '';
        const added = this.toggleItem(productId, handle, title, price, image, url);
        this.updateButton(btn, added);
        this.updateCounters();
        this.showToast(added);
      }
    });
  }

  updateButton(btn, isActive) {
    if (isActive) {
      btn.classList.add('wishlist-active');
      btn.setAttribute('aria-label', 'Eliminar de favoritos');
    } else {
      btn.classList.remove('wishlist-active');
      btn.setAttribute('aria-label', 'Añadir a favoritos');
    }
  }

  updateAllButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const productId = btn.dataset.wishlistToggle;
      this.updateButton(btn, this.hasItem(productId));
    });
  }

  updateCounters() {
    const count = this.getCount();
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  showToast(added) {
    const existing = document.querySelector('.wishlist-toast');
    if (existing) existing.remove();
    const toast = document.createElement('div');
    toast.className = 'wishlist-toast';
    toast.innerHTML = added
      ? '♡ Añadido a favoritos'
      : '✕ Eliminado de favoritos';
    document.body.appendChild(toast);
    setTimeout(() => toast.classList.add('visible'), 10);
    setTimeout(() => {
      toast.classList.remove('visible');
      setTimeout(() => toast.remove(), 300);
    }, 2000);
  }

  renderPage(container) {
    if (!container) return;
    if (this.items.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
          <p>Tu lista de favoritos está vacía</p>
          <a href="/collections/all" class="button accent"><span>Descubrir productos</span></a>
        </div>`;
      return;
    }

    container.innerHTML = '<div class="wishlist-grid"></div>';
    const grid = container.querySelector('.wishlist-grid');

    this.items.forEach(item => {
      const card = document.createElement('div');
      card.className = 'wishlist-card';
      const price = item.price ? (parseFloat(item.price) / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' }) : '';
      card.innerHTML = `
        <a href="${item.url}" class="wishlist-card--image">
          <img src="${item.image}" alt="${item.title}" loading="lazy">
        </a>
        <div class="wishlist-card--info">
          <a href="${item.url}" class="wishlist-card--title">${item.title}</a>
          <p class="wishlist-card--price">${price}</p>
          <div class="wishlist-card--actions">
            <a href="${item.url}" class="button accent"><span>Ver producto</span></a>
            <button class="wishlist-card--remove" data-wishlist-toggle="${item.id}" aria-label="Eliminar de favoritos">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
            </button>
          </div>
        </div>`;
      grid.appendChild(card);
    });
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }
}

window.wishlist = new Wishlist();

document.addEventListener('DOMContentLoaded', () => {
  const wishlistPage = document.querySelector('[data-wishlist-page]');
  if (wishlistPage) {
    window.wishlist.renderPage(wishlistPage);
    wishlistPage.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (btn) {
        setTimeout(() => window.wishlist.renderPage(wishlistPage), 100);
      }
    });
  }
});